export const pageTitle = title => {
  return (document.title =
    title + ' - Get Quality Medical Care with GetAFixMD');
};
